<script setup lang="ts">
import type { ListPaymentOptionsCreditPackage, ListPaymentOptionsSubscriptionDto } from '@swipe4work/models-orval'
import SubscriptionSelectionContent from './components/SubscriptionSelectionContent.vue'

definePage({
  path: 'pakket',
  name: '/onboarding/subscription',
  meta: {
    layout: 'false',
    allowedRoles: [ 'CustomerOnboarding' ],
  },
})

const onboardingStore = useOnboardingStore()
const { companyModel, creditPackage, creditPackages, jobSlotOptions, subscription, subscriptions, wantsSocialMediaPostDiscount } = storeToRefs(onboardingStore)

function prevPage() {
  onboardingStore.goToPage(1)
}

if (companyModel.value === undefined) {
  onboardingStore.goToPage(1)
}

function selectCreditPackage(cp: ListPaymentOptionsCreditPackage) {
  creditPackage.value = cp
  subscription.value = undefined
  onboardingStore.goToPage(3)
  wantsSocialMediaPostDiscount.value = false
}

function selectSubscription(sub: ListPaymentOptionsSubscriptionDto) {
  subscription.value = sub
  creditPackage.value = undefined
  onboardingStore.goToPage(3)
}
</script>

<template>
  <SubscriptionSelectionContent
    :credit-packages="creditPackages"
    :job-slot-options="jobSlotOptions"
    :subscriptions="subscriptions"
    @prev="prevPage"
    @select-credit-package="selectCreditPackage"
    @select-subscription="selectSubscription"
  />
</template>
